import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gkvgpv-chart"
export default class extends Controller {
	static targets = ["chartdata", "chartloading"]

	connect() {
		this.setChartData()
		chartGkvGpv.init()
	}

	chartdataTargetConnected() {
		// Wenn ein neues Target Div mit den Chartdaten das alte ersetzt (durch Stream oder replace)
		// muss das Chart aktualisiert werden
		this.setChartData()
		chartGkvGpv.update()
	}

	chartloadingTargetConnected() {
		// console.log("ChartloadingTargetConnected")
		chartGkvGpv.showLoading()
	}

	chartloadingTargetDisconnected() {
		// console.log("ChartloadingTargetDisconnected")
		chartGkvGpv.hideLoading()
	}

	setChartData() {
		chartGkvGpv.data = JSON.parse(this.chartdataTarget.dataset.chartdata)
	}
}
